import { defineChannel, type ChannelDefinition } from '../channel-definition';

export const inAppChannel = defineChannel({
  id: 'in_app',
  icon: 'in-app',
  name: 'In-App message',
  shortName: 'in-app',
  noun: 'in-app message',
  events: ['attempted', 'sent', 'deferred', 'failed', 'opened', 'clicked', 'converted', 'drafted', 'undeliverable'],
  deliveryStates: ['attempted', 'sent', 'failed', 'holdout'],
  deliveryActions: ['opened', 'clicked', 'converted', 'viewed'],
} as const satisfies ChannelDefinition);
